// Globals
import { useCallback, useEffect, useState } from "react";

// Modules
import { debugBus } from "@/modules/Socket";
import type { TDebugLogEntry } from "@/modules/Socket";

export const useDebugLog = () => {
  const [entries, setEntries] = useState<TDebugLogEntry[]>(() => debugBus.getEntries());

  useEffect(() => debugBus.subscribe(setEntries), []);

  const clear = useCallback(() => debugBus.clear(), []);
  const sendRaw = useCallback((raw: string) => debugBus.sendRaw(raw), []);

  return { entries, clear, sendRaw };
};
